/**
 *
 * ParentList
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { ListGroup, ListGroupItem, Card } from 'react-bootstrap';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import Spinner from 'components/Spinner/index.jsx';
import { useSearch } from 'utils/urlUtils.js';
import messages from './messages.js';
import useParentMeetingSets from '../hooks/useParentMeetingSets.js';
import getSortedMeetings from './getSortedMeetings.js';
import MeetingSlot from './MeetingSlot.jsx';

function ParentList(props) {
  const { studentId } = props; // Can be used without studentId from webview in mobile -> return for all children
  const { connections } = useCurrentRole();
  const sets = useParentMeetingSets();
  const { from } = useSearch();

  function renderBody() {
    if (sets.loading) {
      return <div><Spinner /></div>;
    }
    const meetings = getSortedMeetings(sets, studentId, from);
    if (meetings.length === 0) {
      return <div><FormattedMessage {...messages.nonePlanned} /></div>;
    }
    return (
      <ListGroup>
        {meetings.map((meeting) => (
          <ListGroupItem key={meeting.id}>
            <MeetingSlot meeting={meeting} showStudent={!studentId} />
          </ListGroupItem>
        ))}
      </ListGroup>
    );
  }

  const showLink = connections.length > 1 && studentId;
  return (
    <Card>
      <Card.Body>
        <div className="mb-4">
          <Card.Title as="h2"><FormattedMessage {...messages.header} /></Card.Title>
          {showLink && <Link to="/meetings"><FormattedMessage {...messages.viewAllStudents} /></Link>}
        </div>
        {renderBody()}
      </Card.Body>
    </Card>
  );
}

ParentList.propTypes = {
  studentId: PropTypes.number,
};

export default ParentList;
